import {IHttpService} from "angular";
import {WatchlistRecords} from "../models/WatchlistRecord";
import {CodeAndExchange, Securities} from "app/instruments/types/CodeAndExchange";
import {AccountSecuritiesRecords} from "../models/AccountSecuritiesRecord";
import {extractActualId, WatchlistId} from "../models/WatchlistId";

export class WatchListService {

    public static id = "watchListService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async list(): Promise<WatchlistRecords> {
        const url = "/tradefloor/api/watchlists";
        const response = await this.$http.get<WatchlistRecords>(url);
        return response.data!;
    }

    public async create(name: string): Promise<number> {
        const url = "/tradefloor/api/watchlists";
        const response = await this.$http.post<number>(url, {name});
        return response.data!;
    }

    public async updateName(id: WatchlistId, name: string): Promise<void> {
        const actualId = extractActualId(id);
        const url = `/tradefloor/api/watchlists/${actualId}/name/${name}`;
        await this.$http.put(url, null);
    }

    public async updateItems(id: WatchlistId, items: ReadonlyArray<CodeAndExchange>): Promise<void> {
        const actualId = extractActualId(id);
        const url = `/tradefloor/api/watchlists/${actualId}/items`;
        await this.$http.put(url, items);
    }

    public async delete(id: WatchlistId): Promise<void> {
        const actualId = extractActualId(id);
        const url = `/tradefloor/api/watchlists/${actualId}`;
        await this.$http.delete(url);
    }

    public async accountSecurities(): Promise<AccountSecuritiesRecords> {
        const url = `/tradefloor/api/account-securities`;
        const response = await this.$http.get<AccountSecuritiesRecords>(url);
        return response.data!;
    }

    public async adviserSecurities(): Promise<Securities> {
        const url = "/tradefloor/api/watchlists/adviser";
        const response = await this.$http.get<Securities>(url);
        return response.data!;
    }
}
